import { makeVar, useReactiveVar } from '@apollo/client';

import { SurfaceNodeUnion } from 'graphql/types';

type SelectedNode = string | null;

interface SelectedNodeOperations {
  setSelectedNode(nodeId: string | null): void;
  clearSelectedNode(): void;
  getSelectedNode(): SelectedNode;
  isNodeSelected(node: SurfaceNodeUnion): boolean;
}

const selectedNodeVar = makeVar<SelectedNode>(null);

function setSelectedNode(nodeId: SelectedNode): void {
  if (selectedNodeVar() !== nodeId) {
    selectedNodeVar(nodeId);
  }
}

function getSelectedNode(): SelectedNode {
  return selectedNodeVar();
}

function clearSelectedNode() {
  if (selectedNodeVar()) {
    selectedNodeVar(undefined);
  }
}

function isNodeSelected(node: SurfaceNodeUnion): boolean {
  console.log(' is selected? ', node.id, selectedNodeVar());
  return node.id === selectedNodeVar();
}

const selectedNodeOperations: SelectedNodeOperations = {
  setSelectedNode,
  clearSelectedNode,
  isNodeSelected,
  getSelectedNode,
};

export function useSelectedNode(): [
  SelectedNode,
  (nodeId: SelectedNode) => void,
] {
  const selectedNode = useReactiveVar(selectedNodeVar);

  return [selectedNode, setSelectedNode];
}

export function useSelectedNodeOperations(): SelectedNodeOperations {
  return selectedNodeOperations;
}

export function useIsNodeSelected(node: SurfaceNodeUnion): boolean {
  const selectedNode = useReactiveVar(selectedNodeVar);

  return selectedNode === node.id;
}
